/* src/app/front-layout/data-science/data-science.component.css */
.hero {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 150px 2rem 2rem 2rem;
  margin: 0 auto;
  gap: 2rem;
}
.content-left {
  flex: 1 1 500px;
  max-width: 600px;
}
.badge {
  font-size: 5rem;
  font-weight: 800;
  background:
    linear-gradient(
      270deg,
      #ff0057,
      #ff7c00,
      #ffee00,
      #00ff85,
      #00cfff,
      #8f00ff,
      #ff0057);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-align: left;
  padding-left: 1.5em;
  margin-top: 4rem;
}
.black-text {
  color: #111;
  font-weight: 700;
  font-size: 4rem;
  margin-left: 0.1em;
  margin-top: 1rem;
}
@media (max-width: 768px) {
  .badge {
    font-size: 2.2rem;
    margin-left: 1rem;
    margin-top: 2rem;
    line-height: 1.3;
    word-wrap: break-word;
  }
  .black-text {
    font-size: 1.6rem;
    margin-left: 0.5rem;
    margin-top: 0.8rem;
    line-height: 1;
    word-wrap: break-word;
  }
}
.hero h1 {
  font-size: 3.5rem;
  font-weight: 700;
  margin-top: 8rem;
  margin-left: 7.3rem;
  margin-bottom: 3rem;
  margin-right: -0.5rem;
}
.subtext {
  font-size: 2.8rem;
  margin-bottom: 2rem;
  margin-top: 8rem;
  margin-left: 8.8rem;
  margin-bottom: -1rem;
  margin-right: -0.5rem;
}
.buttons {
  display: flex;
  gap: 2rem;
}
.brochure-btn {
  background: #0ef;
  padding: 0.5rem 2rem;
  border: none;
  border-radius: 25px;
  font-weight: 1000;
  cursor: pointer;
  margin-bottom: 2rem;
  margin-top: 3.5rem;
  margin-left: 8rem;
  margin-bottom: 3rem;
  margin-right: -0.5rem;
}
.video-btn {
  background:
    linear-gradient(
      270deg,
      #ff0057,
      #ff7c00,
      #ffee00,
      #00ff85,
      #00cfff,
      #8f00ff,
      #ff0057);
  background-size: 400% 400%;
  animation: shine-bg 6s linear infinite;
  padding: 1.1rem 4rem;
  border: none;
  border-radius: 25px;
  font-weight: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  margin-bottom: 2rem;
  margin-top: 3.5rem;
  margin-left: 4rem;
  margin-bottom: 3rem;
  margin-right: -0.5rem;
}
@media (max-width: 768px) {
  .video-btn {
    width: 90%;
    padding: 1rem;
    font-size: 1rem;
  }
}
.dashboard-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: -13rem auto 3rem;
  max-width: 100%;
  margin-right: 50px;
}
.dashboard-image {
  width: 400%;
  max-width: 550px;
  height: 780px;
  object-fit: cover;
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(241, 237, 237, 0.15);
}
.challenge-section {
  justify-content: space-between;
  padding: 5rem 2rem;
  background: #fff;
  text-align: center;
  max-width: 1300px;
  margin: 0 auto;
}
.challenge-section .section-heading {
  font-size: 4rem;
  font-weight: bold;
  margin-bottom: 4rem;
  margin-top: -10rem;
}
.challenge-cards {
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10rem;
}
.icon-top-left {
  position: absolute;
  top: -160px;
  left: -100px;
  width: 120px;
  opacity: 0.7;
  z-index: 0;
}
.icon-bottom-right {
  position: absolute;
  bottom: -190px;
  right: -80px;
  top: 50;
  width: 120px;
  opacity: 0.7;
  z-index: 50;
}
.challenge-card {
  flex: 1 1 45%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.challenge-card img {
  width: 100%;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
.apart-section {
  margin-top: 30rem;
  padding: 0;
  text-align: center;
}
.apart-content,
.full-image {
  margin: 0;
  padding: 0;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
.full-image img {
  width: 100%;
  height: auto;
  display: block;
  margin: 0;
  padding: 0;
}
@media (max-width: 768px) {
  .apart-section {
    margin-top: 5rem;
  }
  .apart-section .section-heading {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  .full-image {
    margin-left: 0;
    margin-right: 0;
    left: 0;
    right: 0;
    width: 100%;
  }
  .full-image img {
    width: 100%;
    padding: 0;
  }
}
.placement-path {
  max-width: 1200px;
  margin: 5rem auto;
  text-align: center;
  margin-top: 10x;
}
.placement-path h2 {
  font-size: 4rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}
.placement-path p {
  font-size: 1.5rem;
  margin-bottom: 4rem;
  color: #555;
}
.placement-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.placement-image {
  width: 100%;
  max-width: 1000px;
  height: auto;
  display: block;
}
.program-for-section .section-heading {
  font-size: 4rem;
  margin-bottom: 40px;
}
@media (max-width: 768px) {
  .program-for-section .section-heading {
    font-size: 2.2rem;
    margin-bottom: 30px;
  }
}
.program-for-section {
  margin-top: -10px !important;
}
.program-container {
  background: #d7dde3;
  border-radius: 24px;
  padding: 40px 6px -1px;
  max-width: 1200px;
  margin: 0 auto;
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.15);
}
.audience-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-bottom: 40px;
}
.audience-card {
  background: #fff;
  padding: 20px 25px;
  border-radius: 12px;
  margin-top: 30px;
  width: 280px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.2s ease;
}
.audience-card:hover {
  transform: translateY(-5px);
}
.audience-type.student {
  font-size: 2.2rem;
}
.audience-type.switchers {
  font-size: 2.2rem;
}
.audience-type.seekers {
  font-size: 2.2rem;
}
.audience-type {
  font-size: 1.1rem;
  font-weight: bold;
  background:
    linear-gradient(
      to right,
      #3b82f6,
      #d946ef,
      #f97316);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.audience-image img {
  width: 100%;
  border-radius: 2px;
  margin-top: 1px;
}
.enroll-button-wrapper {
  text-align: center;
  margin-top: 30px;
}
.enroll-button {
  background:
    linear-gradient(
      to right,
      #3b82f6,
      #d946ef,
      #f97316);
  color: white;
  padding: 16px 32px;
  border: none;
  border-radius: 999px;
  font-size: 2.5rem;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.enroll-button:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
.section-heading {
  text-align: center;
  font-size: 6rem;
  font-weight: bold;
  margin-bottom: 80px;
  margin-top: 5px;
  color: #000;
}
.faq-section {
  max-width: 1100px;
  margin: 20px auto;
  padding: -30px 40px;
  background-color: #f9f9f9;
}
.faq-heading {
  text-align: center;
  font-size: 4rem;
  font-weight: bold;
  margin-bottom: 30px;
}
.faq-item {
  border: 1px solid #b3d9ff;
  border-radius: 6px;
  margin-bottom: 30px;
  background: #e6f4ff;
  overflow: hidden;
}
.faq-question {
  width: 100%;
  background: #d9efff;
  padding: 18px 20px;
  font-size: 1.8rem;
  text-align: left;
  border: none;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  color: #003366;
}
.faq-question:hover {
  background-color: #cceaff;
}
.faq-answer {
  padding: 0 20px 20px;
  font-size: 2rem;
  color: #003366;
  background-color: #f0faff;
}
.arrow {
  transition: transform 0.1s ease;
  color: #003366;
}
.arrow.rotated {
  transform: rotate(180deg);
}
@media (max-width: 1024px) {
  .hero {
    padding: 100px 1rem 2rem !important;
    flex-direction: column;
    gap: 1rem;
  }
  .content-left {
    flex: 1 1 100% !important;
    max-width: 100% !important;
    text-align: center;
  }
  h1 {
    font-size: 2.2rem !important;
    margin: 1rem 0 !important;
    text-align: center;
  }
  .highlight-ds,
  .highlight-ai {
    display: inline-block;
  }
  .subtext {
    font-size: 1.8rem !important;
    margin: 1rem 0 !important;
    text-align: center;
  }
  .buttons {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  .brochure-btn,
  .video-btn {
    margin: 0.5rem 0 !important;
    width: 100%;
    max-width: 280px;
    padding: 1rem 2rem !important;
  }
  .dashboard-image-wrapper {
    margin: 2rem auto !important;
  }
  .dashboard-image {
    width: 100% !important;
    height: auto !important;
    max-width: 350px !important;
  }
  .challenge-section {
    padding: 3rem 1rem !important;
  }
  .challenge-section .section-heading {
    font-size: 2.8rem !important;
    margin-bottom: 4rem !important;
  }
  .challenge-cards {
    gap: 4rem !important;
  }
  .challenge-card {
    height: auto !important;
    padding: 1.5rem !important;
  }
  .card-title {
    font-size: 1.8rem !important;
    margin-bottom: 2rem !important;
  }
  .challenge-card ul {
    font-size: 1.3rem !important;
  }
  .icon-top-left,
  .icon-bottom-right {
    display: none !important;
  }
  .apart-section {
    padding: 6rem 1rem 3rem !important;
  }
  .apart-section h2.section-heading {
    font-size: 2.8rem !important;
    margin-bottom: 5rem !important;
  }
  .apart-block {
    flex-direction: column !important;
    gap: 3rem !important;
  }
  .apart-block.left .text-block,
  .apart-block.right .text-block {
    margin: 0 !important;
    text-align: center !important;
    order: 2 !important;
  }
  .apart-block.left .image-block,
  .apart-block.right .image-block {
    margin: 0 auto 2rem !important;
    order: 1 !important;
    max-width: 100% !important;
  }
  .text-block h3 {
    font-size: 2.2rem !important;
  }
  .text-block p {
    font-size: 1.3rem !important;
  }
  .image-connector {
    display: none !important;
  }
  .placement-path h2 {
    font-size: 2.8rem !important;
  }
  .placement-path p {
    font-size: 1.2rem !important;
  }
  .program-for-section .section-heading {
    font-size: 2.8rem !important;
  }
  .audience-card {
    width: 100% !important;
    max-width: 300px !important;
  }
  .enroll-button {
    font-size: 1.8rem !important;
    padding: 1rem 2rem !important;
  }
  .faq-section {
    padding: 20px !important;
  }
  .faq-question {
    font-size: 1.3rem !important;
    padding: 1rem !important;
  }
  .faq-answer {
    font-size: 1.1rem !important;
    padding: 0 1rem 1rem !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .hero {
    padding: 120px 2rem 2rem !important;
  }
  h1 {
    font-size: 2.5rem !important;
  }
  .dashboard-image {
    max-width: 450px !important;
  }
  .challenge-cards {
    gap: 2rem !important;
  }
}
/*# sourceMappingURL=data-science.component.css.map */
